
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("17wiG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $3lbOc = parcelRequire("3lbOc");


var $a1L5E = parcelRequire("a1L5E");

const $7f8f90030369ae01$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $7f8f90030369ae01$var$CardLoadingWithContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $7f8f90030369ae01$var$loadCardWithMediaClient() {
    return (parcelRequire("9YdRw"));
}
const $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
});
const $7f8f90030369ae01$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $7f8f90030369ae01$var$CardLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
        value: props
    }, (0, $iDrrr.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props)));
};
$7f8f90030369ae01$var$CardLoader.preload = ()=>{
    if ((0, $iDrrr.fg)('platform_media_react19_support')) $7f8f90030369ae01$var$loadCardWithMediaClient().then(()=>{});
    else $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $7f8f90030369ae01$export$2e2bcd8739ae039 = $7f8f90030369ae01$var$CardLoader;
module.exports["default"] = $7f8f90030369ae01$export$2e2bcd8739ae039;

});

parcelRegister("3lbOc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $97Pj3 = parcelRequire("97Pj3");


var $8quKc = parcelRequire("8quKc");


var $1pEse = parcelRequire("1pEse");

const $9010bd9f06816b06$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    let t3;
    if ($[2] !== interactionName) {
        t3 = (0, $ieeJu.expValEquals)("cc-maui-ai-edit-loading-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            interactionName: interactionName || "media-card-loading"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            interactionName: interactionName || "media-card-loading"
        });
        $[2] = interactionName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t3);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, (0, $ieeJu.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $9010bd9f06816b06$export$5d25853fd6bdf402;

});

parcelRegister("97Pj3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5EzLH = parcelRequire("5EzLH");

const $9d658d6460d574ed$var$TICK_INTERVAL_MS = 1000;
const $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $9d658d6460d574ed$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $9d658d6460d574ed$var$messages = (0, $kSwu1.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $9d658d6460d574ed$var$trackStyles = null;
const $9d658d6460d574ed$var$fillStyles = null;
const $9d658d6460d574ed$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $9d658d6460d574ed$export$6665614bc5d690f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $9d658d6460d574ed$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $9d658d6460d574ed$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    $9d658d6460d574ed$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: `${$9d658d6460d574ed$var$clampToPercent(progress)}%`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ])
    }));
};
module.exports["LoadingBar"] = $9d658d6460d574ed$export$6665614bc5d690f6;

});

parcelRegister("1pEse", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ew4xH = parcelRequire("ew4xH");

const $edacca4f67c5c3ed$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $ew4xH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $edacca4f67c5c3ed$export$e6dfd72ab29f8598;

});

parcelRegister("ew4xH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $9AILw = parcelRequire("9AILw");

const $b57e90473f867d52$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $b57e90473f867d52$export$491e6397d7c1480b;

});

parcelRegister("9AILw", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 


const $1086bc1f8c9770f0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $1086bc1f8c9770f0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["center"] = $1086bc1f8c9770f0$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $1086bc1f8c9770f0$export$7a57f79000377ca2;

});

parcelRegister("9YdRw", function(module, exports) {

let $74247865cb697226$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74247865cb697226$var$load("dmoEL"),
    $74247865cb697226$var$load("i7f39"),
    $74247865cb697226$var$load("hwJJ4"),
    $74247865cb697226$var$load("Lm7SH"),
    $74247865cb697226$var$load("6OMo6"),
    $74247865cb697226$var$load("aaRXj"),
    $74247865cb697226$var$load("fHlIz"),
    $74247865cb697226$var$load("4QwAJ"),
    $74247865cb697226$var$load("3i44s"),
    $74247865cb697226$var$load("5kI0b"),
    $74247865cb697226$var$load("kYkz1"),
    $74247865cb697226$var$load("jfYeU"),
    $74247865cb697226$var$load("b4nm1"),
    $74247865cb697226$var$load("geXPZ"),
    $74247865cb697226$var$load("aQ5uu"),
    $74247865cb697226$var$load("6wr18"),
    $74247865cb697226$var$load("aOIZj"),
    $74247865cb697226$var$load("9ZyXP"),
    $74247865cb697226$var$load("iiagb"),
    $74247865cb697226$var$load("kHnae"),
    $74247865cb697226$var$load("2u41l"),
    $74247865cb697226$var$load("7EorR"),
    $74247865cb697226$var$load("RI3SR"),
    $74247865cb697226$var$load("ffEVr"),
    $74247865cb697226$var$load("jTOhL"),
    $74247865cb697226$var$load("jOE2W"),
    $74247865cb697226$var$load("cuNBo"),
    $74247865cb697226$var$load("4Ldt2"),
    $74247865cb697226$var$load("2XRLb"),
    $74247865cb697226$var$load("gkVge"),
    $74247865cb697226$var$load("io0qR"),
    $74247865cb697226$var$load("3MJxZ"),
    $74247865cb697226$var$load("kHMR7"),
    $74247865cb697226$var$load("e3OZZ"),
    $74247865cb697226$var$load("cL682"),
    $74247865cb697226$var$load("4MePG"),
    $74247865cb697226$var$load("5JWJI"),
    $74247865cb697226$var$load("7gPXS")
]).then(()=>parcelRequire('gnpwR'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});


//# sourceMappingURL=media.98649401.js.map
